
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function WhoWeWorkWithPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 lg:px-12 bg-[#FAFAF9]">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <div className="text-xs uppercase tracking-[0.2em] text-[#093a3e] font-bold mb-4">
              WHO WE WORK WITH
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Designed for healthcare organizations that carry performance risk
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              Kinra partners with organizations that are accountable for quality outcomes and total cost of care. Our program is flexible across payer and provider environments.
            </p>
          </div>
        </div>
      </section>

      {/* Health Plans Section */}
      <section className="py-24 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <div className="w-16 h-16 bg-[#093a3e]/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-[#093a3e] text-3xl"></i>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Health Plans
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed mb-8">
                Close care gaps, improve Stars/HEDIS performance, and strengthen network performance.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 bg-[#093a3e] text-white px-8 py-4 rounded-full hover:bg-[#062b2f] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap font-semibold group"
              >
                <span>Talk to Us About Stars ROI</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>

            <div>
              <div className="mb-10">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Common Use Cases</h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Raise diabetic eye exam screening rates across targeted geographies</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Improve performance on Stars/HEDIS measures tied to diabetes care</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Deploy rapid screening access where eye care supply is constrained</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Support provider network performance with embedded staff</span>
                  </li>
                </ul>
              </div>

              <div className="bg-[#FAFAF9] rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">What Success Looks Like</h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Measurable lift in screening rate</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Cleaner gap lists and defensible reporting</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Reduced friction for members and providers</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Health Systems Section */}
      <section className="py-24 px-6 lg:px-12 bg-[#FAFAF9]">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div className="lg:order-2">
              <div className="w-16 h-16 bg-[#093a3e]/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-hospital-line text-[#093a3e] text-3xl"></i>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Health Systems & Provider Groups
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed mb-8">
                Add screening capacity without adding burden.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 bg-[#093a3e] text-white px-8 py-4 rounded-full hover:bg-[#062b2f] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap font-semibold group"
              >
                <span>Launch in Clinics</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>

            <div className="lg:order-1">
              <div className="mb-10">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Common Use Cases</h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Offer diabetic eye screening as part of primary care visits</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Reduce leakage and missed referrals</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Support quality initiatives across clinics</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Improve performance under value-based contracts</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-sm">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Systems Choose Kinra</h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Minimal disruption to clinic workflows</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Staffed operational model</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Integrates into existing quality infrastructure</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ACOs Section */}
      <section className="py-24 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <div className="w-16 h-16 bg-[#093a3e]/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-team-line text-[#093a3e] text-3xl"></i>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                ACOs & Risk Organizations
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed mb-8">
                Move quality measures and protect shared savings.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 bg-[#093a3e] text-white px-8 py-4 rounded-full hover:bg-[#062b2f] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap font-semibold group"
              >
                <span>Build an ACO Program</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>

            <div>
              <div className="mb-10">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Common Use Cases</h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Close gaps for attributed diabetic populations</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Improve quality performance tied to shared savings and benchmark scoring</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Reach rural/underserved populations via mobile screening</span>
                  </li>
                </ul>
              </div>

              <div className="bg-[#FAFAF9] rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">What Matters Most</h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Member-level gap closure</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Accurate documentation</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#093a3e] text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">Predictable execution across regions</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-[#093a3e] to-[#062b2f]">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to improve your diabetic eye exam performance?
          </h2>
          <a
            href="/contact"
            className="inline-flex items-center gap-2 bg-white text-[#093a3e] px-10 py-5 rounded-full hover:bg-gray-50 transition-all hover:shadow-lg cursor-pointer whitespace-nowrap font-semibold text-lg group"
          >
            <span>Request a Demo</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
